import type { ComponentType } from 'react';
import { createContext } from 'react';

import type { PoiDataState } from '../types';

import displayName from '@shared/utils-frontend/display-name';

interface ContextProps {
  poiDataState: PoiDataState;
}
const PoiDataContext = createContext({});

const withPoiDataState = <P extends ContextProps>(
  Component: ComponentType<P>,
) => {
  const component = (props: Omit<P, 'poiDataState'>) => (
    <PoiDataContext.Consumer>
      {(contexts) => (
        // @ts-expect-error we expect that poiDataState can be overwritten in the unit tests
        <Component poiDataState={contexts} {...(props as P)} />
      )}
    </PoiDataContext.Consumer>
  );

  component.displayName = displayName(Component);

  return component;
};

export default PoiDataContext;
export { withPoiDataState };
